var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { useState } from 'react';
import { Field, Formik } from 'formik';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import Input from '@mui/material/Input';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { EPaymentType, getPaymentString } from '../../../types';
import { ModalNew } from '../../atoms/Modal/Modal';
import { Delimiter } from '../../atoms/Delimiter';
import { ModalWrapperNew } from '../../atoms/ModalWrapper/ModalWrapper';
const ModalWrapper = styled(ModalWrapperNew) `
  padding: 30px 30px 40px;
`;
const Content = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const BotPayment = styled.span `
  font-size: 12px;
`;
// const Input = styled(Field)`
//   width: 148px;
//   height: 44px;
//   padding: 12px 20px;
//   background: #517573;
//   border: 1px solid #ffffff;
//   border-radius: 47px;
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 20px;
//   color: #ffffff;
//   outline: none;
//
//   &::placeholder {
//     color: rgba(255, 255, 255, 0.7);
//   }
//
//   &:-webkit-autofill {
//     transition: background-color 50000s ease-in-out 0s;
//     -webkit-text-fill-color: #ffffff !important;
//   }
//
//   &:active,
//   &:focus {
//     border: 1px solid #ffd643;
//   }
// `
const Label = styled.label `
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.7);
  position: absolute;
  width: 100%;
  bottom: 100%;
  left: 0;
  transition: 0.3s;
  z-index: -1;
  user-select: none;
`;
const Types = styled.div `
  display: flex;
  justify-content: space-between;
`;
const OtherPayerTypes = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
const Title = styled.div `
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #000;
`;
const InputLabel = styled.div `
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #000;
`;
const InputWrapper = styled.div `
  position: relative;
  z-index: 10;
  margin-top: 19px;
`;
const InputContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const AmountContainer = styled.div `
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const AdminInput = styled(Field) `
  width: 216px;
  height: 28px;
  padding: 0 12px 6px 0;
  background-color: transparent;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000;
  transition: 0.3s;
  border: none;
  border-bottom: 2px solid #000;
  border-radius: 1px;
  outline: none;
  &:not(:placeholder-shown, :focus) {
    & + label {
      bottom: 100%;
      & + img {
        cursor: pointer;
        pointer-events: all;
        opacity: 1;
      }
    }
  }
  &:focus {
    //color: #ffd643;
    //border-bottom: 2px solid #ffd643;
    & + label {
      bottom: 100%;
    }
  }
  &:-webkit-autofill {
    transition: background-color 50000s ease-in-out 0s;
    -webkit-text-fill-color: #ffd643 !important;
  }
`;
const AdditionalPaymentContainer = styled.div `
  display: flex;
  cursor: pointer;
  width: max-content;
  align-items: center;
  user-select: none;
`;
const AdditionalPaymentText = styled.div `
  transition: 0.3s;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ checked }) => (checked ? '#FFD643' : '#FFFFFF')};
`;
const getButtonDescription = (payment) => {
    if (payment === undefined || payment === null) {
        return 'Выбрать';
    }
    if (payment.method === EPaymentType.PAID_BY_OTHER_PLAYER && payment.parentPayment !== null) {
        return `Игрок: ${payment.parentPayment.payerName} (${payment.parentPayment.amount})`;
    }
    if (payment.amount === 0 && payment.method === EPaymentType.FREE) {
        return 'Бесплатно';
    }
    return `${payment.amount} (${getPaymentString(payment.method)})`;
};
export function Payment({ player, onPaymentSubmit, admins, players }) {
    var _a;
    const [isOpen, setIsOpen] = useState(false);
    // const variant: string = !player.payment ? 'outlined' : 'contained'
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ startIcon: _jsx(EditIcon, {}), variant: "outlined", onClick: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setIsOpen(true);
                } }, { children: getButtonDescription(player.payment) })), isOpen && (_jsx(ModalNew, Object.assign({ onClose: () => setIsOpen(false), close: true }, { children: _jsx(ModalWrapper, { children: _jsx(Formik, Object.assign({ initialValues: {
                            playerId: player.id,
                            payment_method: player.payment_method,
                            amount: ((_a = player.payment) === null || _a === void 0 ? void 0 : _a.amount) || null,
                            administratorId: '',
                            paidByOtherPlayer: false,
                            paymentId: null,
                        }, onSubmit: (values, actions) => {
                            onPaymentSubmit(values, actions);
                            setIsOpen(false);
                        } }, { children: ({ values, setFieldValue, submitForm }) => (_jsxs(Content, { children: [_jsxs(Typography, Object.assign({ variant: "h4" }, { children: ["\u041E\u043F\u043B\u0430\u0442\u0430 \u043E\u0442 ", player.player.gameName || player.player.realName] })), _jsx(Delimiter, { top: "30px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0421\u043F\u043E\u0441\u043E\u0431 \u043F\u043B\u0430\u0442\u0435\u0436\u0430" })), _jsx(Delimiter, { top: "15px" }), _jsxs(Types, { children: [_jsx(Button, Object.assign({ variant: "contained", disabled: values.payment_method === EPaymentType.WIRE_TRANSFER, onClick: () => setFieldValue('payment_method', EPaymentType.WIRE_TRANSFER) }, { children: getPaymentString(EPaymentType.WIRE_TRANSFER) })), _jsx(Button, Object.assign({ variant: "contained", disabled: values.payment_method === EPaymentType.FREE, onClick: () => __awaiter(this, void 0, void 0, function* () {
                                                setFieldValue('payment_method', EPaymentType.FREE);
                                                submitForm();
                                            }) }, { children: getPaymentString(EPaymentType.FREE) }))] }), _jsx(Delimiter, { top: "15px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0421\u0443\u043C\u043C\u0430" })), _jsx(Delimiter, { top: "15px" }), _jsxs(Types, { children: [_jsx(Button, Object.assign({ variant: "contained", onClick: () => {
                                                setFieldValue('payment_method', EPaymentType.WIRE_TRANSFER);
                                                setFieldValue('amount', 1500);
                                            } }, { children: "1500" })), _jsx(Button, Object.assign({ variant: "contained", onClick: () => {
                                                setFieldValue('payment_method', EPaymentType.WIRE_TRANSFER);
                                                setFieldValue('amount', 2000);
                                            } }, { children: "2000" })), _jsx(Input, { sx: { color: '#fff' }, value: values.amount, name: "amount", placeholder: "\u0414\u0440\u0443\u0433\u0430\u044F \u0441\u0443\u043C\u043C\u0430", onChange: (event) => setFieldValue('amount', event.target.value) })] }), (values.payment_method === EPaymentType.WIRE_TRANSFER || values.paidByOtherPlayer) && (_jsxs(_Fragment, { children: [_jsx(Delimiter, { top: "30px" }), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430" })), _jsx(Delimiter, { top: "5px" })] })), _jsxs(OtherPayerTypes, { children: [values.payment_method === EPaymentType.WIRE_TRANSFER && (_jsxs(InputWrapper, { children: [_jsxs(AdminInput, Object.assign({ as: "select", name: "administratorId", onChange: (e) => setFieldValue('administratorId', e.target.value) }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u0412\u044B\u0431\u0435\u0440\u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044F" })), admins.map((admin) => (_jsx("option", Object.assign({ value: admin.id }, { children: admin.name }), admin.id)))] })), _jsx(Label, Object.assign({ htmlFor: "administratorId" }, { children: "\u0412\u0435\u0434\u0443\u0449\u0438\u0439" }))] })), values.paidByOtherPlayer && (_jsxs(InputWrapper, { children: [_jsxs(AdminInput, Object.assign({ as: "select", name: "paymentId", onChange: (e) => setFieldValue('paymentId', e.target.value) }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u0412\u044B\u0431\u0435\u0440\u0438 \u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0430" })), players.map((item) => {
                                                            var _a, _b;
                                                            return (_jsxs("option", Object.assign({ value: ((_a = item.payment) === null || _a === void 0 ? void 0 : _a.id) || '' }, { children: [item.player.gameName || item.player.realName, " (", ((_b = item.payment) === null || _b === void 0 ? void 0 : _b.amount) || 0, ")"] }), item.id));
                                                        })] })), _jsx(Label, Object.assign({ htmlFor: "paymentId" }, { children: "\u041A\u0442\u043E \u043F\u0435\u0440\u0435\u0432\u0435\u043B" }))] })), !values.paidByOtherPlayer && _jsx(Delimiter, { top: "47px" })] }), _jsx(Delimiter, { top: "17px" }), _jsx(FormControlLabel, { sx: { width: 'fit-content' }, control: _jsx(Checkbox, { onClick: () => setFieldValue('paidByOtherPlayer', !values.paidByOtherPlayer), checked: values.paidByOtherPlayer }), label: "\u041F\u043B\u0430\u0442\u0435\u0436 \u0432\u043D\u0435\u0441 \u0434\u0440\u0443\u0433\u043E\u0439 \u0438\u0433\u0440\u043E\u043A" }), _jsx(Delimiter, { top: "17px" }), _jsx(Button, Object.assign({ sx: { width: '216px', margin: '0 60px' }, variant: "contained", onClick: () => submitForm() }, { children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }))] })) })) }) })))] }));
}
